

import { forwardRef, useContext } from 'react';

import { Icon } from '../icon/icon';
import { ToneIcon } from '../tone-icon/tone-icon';
import { BannerRootContext } from './context/banner-root.context';
import { bannerIconRecipe } from './styles/banner-icon.styles';
import type { BannerIconPropsInterface } from './types/banner-icon.types';

/**
 * @since 7.13.0
 */
export const BannerIcon = forwardRef<SVGSVGElement, BannerIconPropsInterface>(
  (props, forwardedRef) => {
    const { tone = 'info' } = useContext(BannerRootContext);
    const { css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="Banner.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        css={{ ...bannerIconRecipe.raw({ tone }), ...cssProp }}
        size="md"
        {...rest}
      >
        <ToneIcon tone={tone} />
      </Icon>
    );
  },
);

BannerIcon.displayName = 'Banner.Icon';
